var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Report"}},[(!_vm.url)?_c('h2',[_vm._v("Dashboard not ready for this sistem")]):_vm._e(),(_vm.url)?_c('vue-friendly-iframe',{attrs:{"src":_vm.url}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }